//
//
//
//
//
//
//
//

export default {
  name: 'FileIcon',
  props: {
    color: {
      type: String,
      default: '#00A669'
    },
    title: {
      type: String,
      default: ''
    }
  }
}
